import Nullstack from 'nullstack';
export default function IconAirConditioning({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-air-conditioning",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 16a3 3 0 0 1 -3 3"
  }), "   ", Nullstack.element("path", {
    d: "M16 16a3 3 0 0 0 3 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v4"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "8",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3"
  }), " ");
}